import { Injectable } from '@angular/core';
import { CompareDataTreatmentsStored } from '../compare-data-treatments-stored';

@Injectable()
export class CompareMultipleWellNavigatorDataService extends CompareDataTreatmentsStored {
  constructor() {
    super();
  }
}
